import axios from "@util/axios";
import store from "@store";

class RolesService {
	constructor() {
		this.roles = store.getters.roles;
		this.role = store.getters.role;

		store.subscribe((mutation, state) => {
			this.role = state.roles.role;
			this.roles = state.roles.roles;
		});
	}

	set(type = "role", data) {
		if ("list" === type)
			store.commit(
				"GET_ROLES",
				data
					? {
							count: data.length,
							results: data,
					  }
					: null
			);
		else
			store.commit(
				data && data.id === this.role.id ? "UPDATE_ROLE" : "READ_ROLE",
				data
					? {
							data: data,
					  }
					: null
			);
	}

	async list(params, commit = true) {
		const response = await axios({
			url: `/role/`,
			params: params,
		});

		if (commit) store.commit("GET_ROLES", response.data.data);

		return response;
	}

	async create(data, commit = true) {
		const response = await axios({
			url: `/role/`,
			method: "POST",
			data: data,
		});

		if (commit) store.commit("CREATE_ROLE", response.data.data);

		return response;
	}

	async read(data, commit = true) {
		const response = await axios({
			url: `/role/${data.id}/`,
		});

		if (commit) store.commit("READ_ROLE", response.data.data);

		return response;
	}

	async update(data, commit = true) {
		const response = await axios({
			url: `/role/${data.id}/`,
			method: "PUT",
			data: data,
		});

		if (commit) store.commit("UPDATE_ROLE", response.data.data);

		return response;
	}

	async delete(data, commit = true) {
		const response = await axios({
			url: `/role/${data.id}/`,
			method: "DELETE",
		});

		if (commit)
			store.commit("DELETE_ROLE", {
				data: data,
			});

		return response;
	}
}

export default new RolesService();
